import { c as _c } from "react-compiler-runtime";
import { useEffect } from 'react';
export default function useElementResizeObserver(elementRef, memoizedCallback) {
  "use memo";

  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== elementRef || $[1] !== memoizedCallback) {
    t0 = () => {
      const handleResizeObserver = new ResizeObserver(memoizedCallback);
      if (elementRef) {
        handleResizeObserver.observe(elementRef);
      }
      return () => handleResizeObserver.disconnect();
    };
    t1 = [elementRef, memoizedCallback];
    $[0] = elementRef;
    $[1] = memoizedCallback;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}